import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn:'root'
})
export class AuthService extends ApiBaseService {
  private userInSessionSubject = new BehaviorSubject<any>(null);
  userInSession$ = this.userInSessionSubject.asObservable();

  constructor() { 
    super();
    this.initializeUserFromLocalStorage();
  }

  private initializeUserFromLocalStorage(): void {
    const userData = localStorage.getItem('user');
    if (userData) {
      try {
        const user = JSON.parse(userData);
        this.setUserInSession(user);
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
      }
    }
  }

  setUserInSession(user: any): void {
    this.userInSessionSubject.next(user);
  }

  getUserInSession(): Observable<any> {
    return this.userInSession$;
  }

  clearUserInSession(): void {
    this.userInSessionSubject.next(null);
  }

  token(username: string, password: string) : Observable<any> {
    const params = new URLSearchParams();
    params.append('grant_type', 'client_credentials');
    params.append('tenant', 'GLOBAL_LAB_LTD');
    params.append('username', username);
    params.append('password', password);

    return this.POSTUrlEncoded(this.getUrl('/auth/token'), params);
  }

  verifyMfaToken(mfaToken: string, code: string): Observable<any> {
    const params = new URLSearchParams();
    params.append('grant_type', 'mfa');
    params.append('mfa_token', mfaToken);
    params.append('code', code);

    return this.POSTUrlEncoded(this.getUrl('/auth/token'), params);
  }

  impersonate(userId: string): Observable<any> {
    return this.POST(this.getUrl(`/auth/impersonate/${userId}`), {});
  }
}
